import React, { useState, useEffect } from 'react';

export default function TextFilter({ value, operator, onChange, onApply }) {
  const [localVal, setLocalVal] = useState(value);
  const [op, setOp] = useState(operator || 'contiene');

  useEffect(() => { setLocalVal(value); }, [value]);
  useEffect(() => { setOp(operator || 'contiene'); }, [operator]);

  const handleOpChange = (e) => {
    setOp(e.target.value);
    onChange(localVal, e.target.value);
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      onChange(localVal, op);
      if (onApply) onApply();
    }
  };

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
      <select className="cm-filter-select" value={op} onChange={handleOpChange}>
        <option value="contiene">Contiene</option>
        <option value="no_contiene">No contiene</option>
        <option value="igual">Igual</option>
        <option value="diferente">Diferente</option>
      </select>
      <input
        className="cm-filter-input"
        type="text"
        value={localVal}
        onChange={(e) => { setLocalVal(e.target.value); onChange(e.target.value, op); }}
        onKeyDown={handleKeyDown}
        placeholder="Buscar..."
      />
    </div>
  );
}
